(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7882"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7882"] = parcelRequire;
}
parcelRequire.register("d8HMG", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $990dfc566758140d$export$6503ec6e8aabbaf; }, function (v) { return $990dfc566758140d$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $990dfc566758140d$export$f7ad0328861e2f03; }, function (v) { return $990dfc566758140d$export$f7ad0328861e2f03 = v; });
var $990dfc566758140d$export$6503ec6e8aabbaf;
var $990dfc566758140d$export$f7ad0328861e2f03;
"use strict";
var $990dfc566758140d$var$mapping = {};
function $990dfc566758140d$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$990dfc566758140d$var$mapping[keys[i]] = pairs[keys[i]];
}
function $990dfc566758140d$var$resolve(id) {
    var resolved = $990dfc566758140d$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$990dfc566758140d$export$6503ec6e8aabbaf = $990dfc566758140d$var$register;
$990dfc566758140d$export$f7ad0328861e2f03 = $990dfc566758140d$var$resolve;

});

var $5d0463638644c73c$exports = {};

(parcelRequire("d8HMG")).register(JSON.parse('{"7Xv15":"index.ab8fff44.js","18njo":"pandora-logo.5abbd1dd.png"}'));

})();
//# sourceMappingURL=index.c711ed2d.js.map
